import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

export const SidebarAside = styled.aside<{ $isOpen: boolean }>`
  width: ${({ theme }) => theme.layout.sidebarWidth};
  min-height: 100vh;
  background: linear-gradient(180deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.primaryDark} 100%);
  color: ${({ theme }) => theme.colors.textInverse};
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ theme }) => theme.zIndex.fixed};
  transition: transform ${({ theme }) => theme.transitions.slow};

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: ${({ theme }) => theme.radii.full};
    &:hover {
      background-color: rgba(255, 255, 255, 0.25);
    }
  }

  @media (max-width: 767.98px) {
    transform: translateX(-100%);

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        transform: translateX(0);
      `}
  }
`;

export const Brand = styled.div`
  padding: ${({ theme }) => `${theme.spacing[6]} ${theme.spacing[5]}`};
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;

  h1 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: ${({ theme }) => theme.fontSizes.xl};
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    color: ${({ theme }) => theme.colors.textInverse};
    margin: 0;
    letter-spacing: 0.01em;
  }
`;

export const BrandLogo = styled.img`
  width: 36px;
  height: 36px;
  margin-right: ${({ theme }) => theme.spacing[3]};
  flex-shrink: 0;
`;

export const Nav = styled.nav`
  flex: 1;
  padding: ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[3]};
  overflow-y: auto;
`;

export const Footer = styled.div`
  padding: ${({ theme }) => `${theme.spacing[4]} ${theme.spacing[5]}`};
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: rgba(255, 255, 255, 0.4);
`;

export const NavItemLink = styled(NavLink)<{ $active: boolean; $sub?: boolean }>`
  display: flex;
  align-items: center;
  padding: ${({ theme, $sub }) =>
    $sub ? `${theme.spacing[1]} ${theme.spacing[4]}` : `${theme.spacing[3]} ${theme.spacing[4]}`};
  font-size: ${({ theme, $sub }) => ($sub ? '0.8125rem' : theme.fontSizes.base)};
  margin-bottom: 2px;
  color: rgba(255, 255, 255, 0.65);
  text-decoration: none;
  transition: all ${({ theme }) => theme.transitions.base};
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radii.lg};
  border-left: 3px solid transparent;

  &:hover {
    background-color: rgba(255, 255, 255, 0.06);
    color: ${({ theme }) => theme.colors.textInverse};
    text-decoration: none;
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      background-color: rgba(255, 255, 255, 0.1);
      color: ${theme.colors.textInverse};
      border-left-color: ${theme.colors.accent};
      font-weight: ${theme.fontWeights.semibold};
    `}
`;

export const ChevronToggle = styled.span`
  margin-left: auto;
  opacity: 0.5;
  display: inline-flex;
  align-items: center;
`;

export const NavIcon = styled.span`
  width: 1.375rem;
  height: 1.375rem;
  margin-right: ${({ theme }) => theme.spacing[3]};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const NavLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const CourtCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.375rem;
  height: 1.25rem;
  padding: 0 ${({ theme }) => theme.spacing[1]};
  border-radius: ${({ theme }) => theme.radii.full};
  background-color: rgba(212, 168, 67, 0.2);
  color: ${({ theme }) => theme.colors.accentLight};
  font-size: 0.6875rem;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  margin-left: ${({ theme }) => theme.spacing[2]};
`;

export const SubNavContainer = styled.div`
  padding-left: ${({ theme }) => theme.spacing[4]};
  margin-left: ${({ theme }) => theme.spacing[6]};
  border-left: 1px solid rgba(255, 255, 255, 0.1);
`;

export const Overlay = styled.div<{ $visible: boolean }>`
  display: none;

  @media (max-width: 767.98px) {
    display: block;
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: ${({ theme }) => theme.zIndex.fixed - 1};
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
    transition: opacity ${({ theme }) => theme.transitions.base};
  }
`;
